module.exports = __webpack_public_path__ + "img/refrigeration-image-placeholder.97381827.png";